/**
 * Specifies the number of callbacks to trigger on each batch that is being run
 * in the background.
 */
const BATCH_SIZE = 10;

/**
 * Specifies how frequently to allow batches to run in the background.
 */
const BATCH_INTERVAL = 10;

/**
 * Specifies how long to delay batch execution from the time that we've first
 * been asked to run callbacks till the first one will be executed.
 */
const BATCH_DELAY = 200;

/**
 * State variable used to keep track of whether or not we've already created a
 * timeout to run the next set of queued up operations.
 */
let isPending = false;

/**
 * Contains the queued set of operations to be performed in the background.
 */
const queue = [];

/**
 * Helper that'll mark the given callback for background execution, so it wont
 * overload the CPU if a lot of operations are being run simultaneously.
 */
function runInBackground(callback) {
  // Push the callback to the list of queued up operations
  queue.push(callback);

  // If we're not already waiting to run a batch of background operations,
  // then create a timeout to do so now
  if (!isPending) {
    // Register that we've queued up operations to perform the next batch of
    // operations
    isPending = true;

    // Set a timeout to run the next batch of operations in 10 milliseconds
    setTimeout(runBatchOfCallbacks, BATCH_DELAY);
  }
}

/**
 * Internal helper that runs the next 10 operations, and then sets a timeout to
 * perform next batch in 10 milliseconds to avoid overloading the CPU.
 */
function runBatchOfCallbacks() {
  // Extract the next callbacks to execute
  const callbacks = queue.splice(0, BATCH_SIZE);
  if (queue.length > 0) {
    // If there are more callbacks queued up, then run another batch in 10ms
    setTimeout(runBatchOfCallbacks, BATCH_INTERVAL);
  } else {
    // ... Otherwise register that background operations are no longer
    // pending
    isPending = false;
  }
  for (const callback of callbacks) {
    setTimeout(callback);
  }
}

export { runInBackground };
//# sourceMappingURL=runInBackground.js.map
